module.exports = __webpack_public_path__ + "img/Icon_Incomplete.bb490e0a.svg";